/* eslint-disable */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Content } from '@pcln/ace-content-react'
import { Text, Box, Button } from 'pcln-design-system'
import EmailContainer from './units/EmailContainer'
import EmailBannerWrapper from './units/EmailBannerWrapper'
import EmailBanner from './units/EmailBanner'
import EmailFormWrapper from './units/EmailFormWrapper'
import EmailInput from './units/EmailInput'
import EmailErrorTooltip from './units/EmailErrorTooltip'
import * as PCLNAnalytics from '../../utils/PCLN-Analytics'
import { ANALYTICS_CATEGORY } from '../../constants/Constants'
import EmailSignUpActions from '../../actions/EmailSignUpActions'
import HomepageDispatcher from '../../dispatcher/dispatcher'
import ActionTypes from '../../constants/Action-Types'
import { EMAIL_REGEXP } from '../../constants/sign-up-content'

class EmailSignup extends Component {
  
  static defaultProps = {
    email: PropTypes.string,
    disabledInput: PropTypes.bool,
    success: PropTypes.bool,
    syncing: PropTypes.bool,
    valid: PropTypes.bool,
    validInput: PropTypes.bool
  }

  constructor(props) {
    super(props)
    this.state = {
      email: '',
      disabledInput: false,
      success: false,
      syncing: false,
      valid: false,
      validInput: true
    }
    this.emailInput = React.createRef()
  }

  focusEmailInput = () => {
    this.emailInput.current.focus();
  }

  validate = () => {
    return {
      email: EMAIL_REGEXP.test(this.state.email)
    }
  }

  handleEmailInput = event => {
    const validity = this.validate()

    this.setState({ email: event.target.value, valid: validity.email })
  }

  handleSubmit = e => {
    if (!this.state.valid) {
      this.setState({ validInput: false })
      this.focusEmailInput()
      PCLNAnalytics.send({
        category: ANALYTICS_CATEGORY,
        action: 'Email Signup',
        data: 'Invalid'
      })

      return
    }

    this.setState({ disabledInput: true })
    PCLNAnalytics.send({
      category: ANALYTICS_CATEGORY,
      action: 'Email Signup',
      data: 'Valid'
    })

    this.setState({ syncing: true, validInput: true })

    EmailSignUpActions.submit(
      this.state.email,
      'LANDING_HOME_TEST',
      this.handleSignUpError.bind(this)
    )

    HomepageDispatcher.register(action => {
      if (action.type === ActionTypes.EMAIL_SIGN_UP_SUBMIT) {
        this.setState({ syncing: false, success: true })

        PCLNAnalytics.send({
          category: ANALYTICS_CATEGORY,
          action: 'Email Confirm',
          data: 'Thank You'
        })
      }
    })
  }

  handleSignUpError = () => {
    // Pad the time so failure is not immediate
    setTimeout(() => {
      this.setState({ syncing: false })
    }, 1000)
  }

  render () {
    const { success, syncing, validInput, disabledInput } = this.state

    return (
      <EmailContainer color='#fefefe' justifyContent='center' m={0}>
        <EmailBannerWrapper alignItems='center' justifyContent='center' py={2}>
          <EmailBanner color='text' py={2} fontWeight='bold' fontSize={3}>
            {!success ? (
              <React.Fragment>
                <Content
                  children={this.props.HOME_CONTENT.title}
                  name={['HOMEPAGE.EMAILSIGNUP.TITLE', 'value']}
                />
                <Text color='text.light' fontSize={1} pt={2}>
                  <Content
                    children={this.props.HOME_CONTENT.subtitle}
                    name={['HOMEPAGE.EMAILSIGNUP.SUBTITLE', 'value']}
                  />
                </Text>
              </React.Fragment>
            ) : (
              <Content
                children={this.props.HOME_CONTENT.success}
                name={['HOMEPAGE.EMAILSIGNUP.SUCCESS', 'value']}
              />
            )}
          </EmailBanner>
          {!success && (
            <EmailFormWrapper color='text' py={2} ml={5}>
              <Box>
                <EmailInput
                  aria-label='Promotion Input'
                  aria-describedby='promotion_error'
                  name='signUpPromotion'
                  color={!validInput ? 'error' : ''}
                  innerRef={this.emailInput}
                  onChange={this.handleEmailInput}
                  placeholder={this.props.HOME_CONTENT.form.emailInputPlaceholder}
                />
                <Box id='promotion_error'>
                  {!validInput && <EmailErrorTooltip/>}
                </Box>
              </Box>
              <Box>
                <Button
                  disabled={disabledInput}
                  ml={2}
                  onClick={this.handleSubmit}
                  px={4}
                  variation='outline'
                >
                  {!syncing && (
                    <Text fontSize={1}>
                      {this.props.HOME_CONTENT.form.submit}
                    </Text>
                  )}
                  {syncing && (
                    <Text fontSize={1}>
                      {this.props.HOME_CONTENT.form.sync}
                    </Text>
                  )}
                </Button>
              </Box>
            </EmailFormWrapper>
          )}
        </EmailBannerWrapper>
      </EmailContainer>
    )
  }
}

export default EmailSignup
